import type { ReactNode } from "react";

export function getDetailFieldValue(
  data: Record<string, unknown> | null,
  field: string,
): ReactNode {
  if (data != null && field in data) {
    return data[field] as ReactNode;
  }
  return undefined;
}
